export default __webpack_public_path__ + "static/Moniqa-MediumParagraph-e59bf80fc8022b228fd8c18fd41f31fe.woff";